import { getContrast, readableColor } from 'polished';

// Wrapper sobre polished con las reglas de negocio de PROLIFT.
// Validacion autoritative vive en el backend (API-PROAPP/src/utils/colorValidation.ts);
// este archivo es el espejo en el frontend para UX (preview + bloqueo de submit).

export const WCAG_AA_NORMAL = 4.5;
export const WCAG_AA_LARGE = 3.0;
export const WCAG_AAA_NORMAL = 7.0;

const HEX_REGEX = /^#[0-9a-fA-F]{6}$/;

export const isValidHex = (c) => typeof c === 'string' && HEX_REGEX.test(c);

// Devuelve '#ffffff' o '#000000' segun cual contraste mejor con el background.
// El cuarto parametro `strict=false` hace que polished use luminancia en lugar
// de contrastRatio completo (mas rapido y coincide con el calculo del backend).
export const autoTextColor = (bg) => {
  if (!isValidHex(bg)) return '#000000';
  return readableColor(bg, '#000000', '#ffffff', false);
};

// Ratio contra el texto auto-calculado (mejor caso, hasta 21).
export const bestContrastRatio = (color) => {
  if (!isValidHex(color)) return 0;
  const text = autoTextColor(color);
  return getContrast(color, text);
};

export const passesAA = (color) => bestContrastRatio(color) >= WCAG_AA_NORMAL;
export const passesAAA = (color) => bestContrastRatio(color) >= WCAG_AAA_NORMAL;

// 'fail' | 'aa' | 'aaa' — util para badges en la UI.
export const wcagLevel = (color) => {
  const r = bestContrastRatio(color);
  if (r >= WCAG_AAA_NORMAL) return 'aaa';
  if (r >= WCAG_AA_NORMAL) return 'aa';
  return 'fail';
};
